import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from "react";
const useKeydown = (key, cb) => {
  const $ = _c(6);
  const callbackRef = useRef(undefined);
  let t0;
  let t1;
  if ($[0] !== cb) {
    t0 = () => {
      callbackRef.current = cb;
    };
    t1 = [cb];
    $[0] = cb;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  let t3;
  if ($[3] !== key) {
    t2 = () => {
      const handleEvent = e => {
        if (e.key === key && callbackRef.current) {
          callbackRef.current(e);
        }
      };
      window.addEventListener("keydown", handleEvent);
      return () => {
        window.removeEventListener("keydown", handleEvent);
      };
    };
    t3 = [key];
    $[3] = key;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  useEffect(t2, t3);
};
export default useKeydown;